import React, { useState } from "react";
import { Modal, Button, ModalBody } from "react-bootstrap";

const WarningModal = (props) => {
	const proceedHandler = () => {
		props.processDeleteHandler();
	};
	return (
		<Modal show={props.showWarning} animation={true} onHide={props.handleCloseWarningModal} id="warning">
			<Modal.Body>
				<div class="warn-wrap">
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path
								d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
								fill="#EB5757"
							></path>
							<path
								d="M12 7V13"
								stroke="#F2F2F2"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
							<path
								d="M12 17H12.01"
								stroke="#F2F2F2"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							></path>
						</svg>
					</span>
					<div class="right-text">
						<h4>{props.title}</h4>
						<p>{props.body}</p>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer className="pb-2">
				<button type="button" class="btn btn-blue" data-dismiss="modal" onClick={props.handleCloseWarningModal}>
					Cancel
				</button>
				<button type="button" class="warn-btn" data-dismiss="modal" onClick={proceedHandler}>
					Proceed
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default WarningModal;



// WEBPACK FOOTER //
// ./src/components/WarningModal.js